// extracted by mini-css-extract-plugin
export default {"root":"IconPlay_root__cwPNw"};